const TOGGLE_SELECTED = 'PAZE_TOGGLE_SELECTED';
const SET_READY = 'PAZE_SET_READY';
const SHOW_INLINE_ERROR = 'PAZE_SHOW_INLINE_ERROR';
const RESET_PAZE_ERROR = 'RESET_PAZE_ERROR';

export {
    TOGGLE_SELECTED, SET_READY, SHOW_INLINE_ERROR, RESET_PAZE_ERROR
};
